/** @format */

import React from "react";

// import styles from './CustonItem.module.scss';
// import useCustonItem from './useCustonItem';

export default function CustonItem({
	text = "no text",
	type = "Essentials",
}: {
	text: string;
	type: "Essentials" | "Premium";
}) {
	if (type === "Premium") {
		return (
			<>
				<div className="container-item--custon">
					<svg
						className="item-svg"
						viewBox="0 0 21 21"
						fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M10.5 0.34375C4.87561 0.34375 0.34375 4.87561 0.34375 10.5C0.34375 16.1244 4.87561 20.6562 10.5 20.6562C16.1244 20.6562 20.6562 16.1244 20.6562 10.5C20.6562 9.40747 20.5098 8.31799 20.1191 7.30176L18.8496 8.54688C19.0052 9.17249 19.0938 9.7981 19.0938 10.5C19.0938 15.2668 15.2668 19.0938 10.5 19.0938C5.73315 19.0938 1.90625 15.2668 1.90625 10.5C1.90625 5.73315 5.73315 1.90625 10.5 1.90625C12.8438 1.90625 14.9495 2.84009 16.4326 4.32324L17.5312 3.22461C15.7338 1.42712 13.2344 0.34375 10.5 0.34375ZM19.3135 3.68848L10.5 12.502L7.15527 9.15723L6.03223 10.2803L9.93848 14.1865L10.5 14.7236L11.0615 14.1865L20.4365 4.81152L19.3135 3.68848Z"
							fill="white"
						/>
					</svg>
					<span className="text-item--premiun">{text}</span>
				</div>
				<style>
					{`
					.text-item--premiun {
						color: white;
						font-style: normal;
						font-weight: 450;
						font-size: 17px;
						line-height: 30px;
					}
          .container-item--premiun {
            display: grid;
            grid-template-columns: 1.2rem auto;
            gap: 1rem;
            align-items: center;
            padding: 0.5rem;
          }
          .item-svg  {
            width: 21px;
            height: 21px;
            // width: 21px !important;
            // fill: red !important;
        }
        .item-svg > path {
              height: 21px;
            width: 21px;
            // width: 21px !important;
            // fill: red !important;
          }
          `}
				</style>
			</>
		);
	}

	return (
		<>
			<div className="container-item--custon">
				<svg
					className="item-svg"
					viewBox="0 0 21 21"
					fill="none"
					xmlns="http://www.w3.org/2000/svg">
					<path
						d="M10.5 0.34375C4.87561 0.34375 0.34375 4.87561 0.34375 10.5C0.34375 16.1244 4.87561 20.6562 10.5 20.6562C16.1244 20.6562 20.6562 16.1244 20.6562 10.5C20.6562 9.40747 20.5098 8.31799 20.1191 7.30176L18.8496 8.54688C19.0052 9.17249 19.0938 9.7981 19.0938 10.5C19.0938 15.2668 15.2668 19.0938 10.5 19.0938C5.73315 19.0938 1.90625 15.2668 1.90625 10.5C1.90625 5.73315 5.73315 1.90625 10.5 1.90625C12.8438 1.90625 14.9495 2.84009 16.4326 4.32324L17.5312 3.22461C15.7338 1.42712 13.2344 0.34375 10.5 0.34375ZM19.3135 3.68848L10.5 12.502L7.15527 9.15723L6.03223 10.2803L9.93848 14.1865L10.5 14.7236L11.0615 14.1865L20.4365 4.81152L19.3135 3.68848Z"
						fill="#58BB71"
					/>
				</svg>
				<span className="text-item--custon">{text}</span>
			</div>
			<style>
				{`
					.text-item--custon {
						font-style: normal;
						font-weight: 450;
						font-size: 17px;
						// line-height: 30px;
					}
          .container-item--custon {
            display: grid;
            grid-template-columns: 1.2rem auto;
            gap: 1rem;
            align-items: center;
            padding: 0.5rem;
          }
          .item-svg  {
            width: 21px;
            height: 21px;
            // width: 21px !important;
            // fill: red !important;
        }
        .item-svg > path {
              height: 21px;
            width: 21px;
            // width: 21px !important;
            // fill: red !important;
          }
          `}
			</style>
		</>
	);
}
